import { Component, Input, OnInit } from '@angular/core';
import { PersonAbstractResource } from 'src/app/models/abstract.model';
import { HTTP_CONTENT_HEADERS } from '../../data/const.data';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AbstractService } from 'src/app/services/data/abstract.service';
import { tap } from 'rxjs/operators';
import * as saveAs from 'file-saver';

@UntilDestroy()
@Component({
  selector: 'app-person-conference-abstract-view',
  templateUrl: './person-conference-abstract-view.component.html',
  styleUrls: ['./person-conference-abstract-view.component.css']
})
export class PersonConferenceAbstractViewComponent implements OnInit {
  @Input() data: PersonAbstractResource[] = [];

  constructor(
    private abstractService: AbstractService,
  ) { }

  columns: any[] = [
    { field: 'fullName', header: 'ФИО', class: 'column-text' },
    { field: 'city', header: 'Город', class: 'column-text' },
    { field: 'country', header: 'Страна', class: 'column-text' },
    { field: 'conferenceName', header: 'Компания', class: 'column-text' },
  ];

  ngOnInit(): void {
  }

  onDownloadPoster(obj: PersonAbstractResource) {
    // console.log(obj)
    this.abstractService.downloadAbstractPoster(obj.conferenceId, obj.id)
    .pipe(
      untilDestroyed(this),
      tap((response) => {
        const file = new Blob([response.body], { type: HTTP_CONTENT_HEADERS.Pdf });
        const fileName = `poster-${obj.id}.pdf`;
        saveAs(file, fileName);
      })
    ).subscribe();
  }

  onFollowTheLink(obj: PersonAbstractResource) {
    window.open(obj.videoLink);
  }

  onPrint(item: PersonAbstractResource) {
    this.abstractService.pdfCertificate(item.conferenceId, item.id).pipe(
      untilDestroyed(this),
      tap((res) => {
        const fileURL = URL.createObjectURL(res);
        window.open(fileURL, '_blank');
      })
    ).subscribe();
  }


}
